import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../commonComponents/translate';
import AccessSessionProp from '../../../../../../commonComponents/propTypes/accessSessionProp';
import SessionItemDetail from '../../../../../sessions/detail/SessionItemDetail';
import LoggedUserContext from '../../../../../../contextProviders/LoggedUserContext';
import { compose } from '../../../../../../services/utilityFunctions';
import withCSRF from '../../../../../../commonComponents/withCSRF';
import CountryProp from '../../../../../../commonComponents/forms/Address/CountryProp';
import ListTrainer from '../../../../../sessions/list/listItem/ListTrainer';
import { useSanitize } from '../../../../../../services/customHooks';

function Information({ t, session, _csrf, languages, journeyId, onRefresh }) {
  const { description: sessionDescription, trainer } = session;
  const description = useSanitize(sessionDescription);
  const { loggedUser } = useContext(LoggedUserContext);

  return (
    <div className="information-tab">
      <SessionItemDetail
        t={t}
        sessions={session}
        onEnroll={undefined}
        languages={languages}
        userId={loggedUser._id}
        _csrf={_csrf}
        isFromJourney={journeyId}
        onRefresh={onRefresh}
      />
      <div className="infos">
        {description && (
          <div className="row">
            <div className="col-lg-12">
              <h5>{t('sessionDetails_about')}</h5>
              <div
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
                style={{ marginTop: '1rem' }}
              />
            </div>
          </div>
        )}
        {trainer && (
          <div className="row">
            <div className="col-lg-12">
              <h5>{t('user_type_trainer')}</h5>
              <div className="sessionDetail-container-body">
                <ListTrainer user={trainer} t={t} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

Information.propTypes = {
  t: PropTypes.func.isRequired,
  journeyId: PropTypes.string.isRequired,
  session: PropTypes.shape(AccessSessionProp.propType).isRequired,
  _csrf: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  onRefresh: PropTypes.func.isRequired,
};
Information.defaultProps = {};
export default compose(translate, withCSRF)(Information);
